import Network from './Requests';
import { setCurrent } from '../store/reducers/variantSlice';

export async function selectProjectVariant({ variant, dispatch, signal }) {
  if (signal?.aborted) {
    return;
  }
  const calculationInfo = await new Network().GetCalculationViews(variant.calculationGuid, signal);
  if (signal?.aborted) {
    return;
  }
  if (!calculationInfo) {
    throw new Error('Calculation views are unavailable.');
  }
  const selected = {
    calculationGuid: variant.calculationGuid,
    calculationName: variant.calculationName,
    createdAt: variant.createdAt,
    iconPath: calculationInfo.mainIconPath,
    idCompany: variant.idCompany,
    idQuality: variant.idQuality,
    isMainVariant: variant.isMainVariant,
    projectGuid: variant.projectGuid,
    timestamp: variant.timestamp,
    sphere_360Path: calculationInfo.sphere_360Path,
    sequenceData: calculationInfo.sequenceData,
  };
  if (calculationInfo.sphere_360Path != null && !calculationInfo.sphere_360Path.includes('default')) {
    const azimuth = await new Network().GetFileAzimuth(calculationInfo.sphere_360Path, signal);
    selected.azimuth = azimuth?.azimuth;
  }
  if (!signal?.aborted) {
    dispatch(setCurrent(selected));
  }
}
